import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { InventoryItem, LaunchDarklyService, QuestionDTO, DateUtilsService, GetUserQuestionHistory, QuestionsState, DetailsState } from 'remarketing-angular-library';
import { finalize, mergeMap, take } from 'rxjs/operators';
import { DateTimeFormat } from 'remarketing-angular-library/enums/dateTime.enum';
import { NgClass, AsyncPipe } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'lib-view-history',
    templateUrl: './view-history.component.html',
    styleUrls: ['./view-history.component.scss'],
    imports: [TranslocoDirective, NgClass, AsyncPipe]
})
export class ViewHistoryComponent implements OnInit {
  @Input() index?: string;
  @Input() dealerUuid: string;
  @Input() userUuid: string;
  loading = false;
  questionHistory$: Observable<QuestionDTO[]>;
  inventoryItem: InventoryItem;
  showUserName = false;

  constructor(
    private readonly store: Store,
    private readonly _launchDarklyService: LaunchDarklyService,
    private readonly dateUtilService: DateUtilsService
    ) {}

  ngOnInit() {
    this.questionHistory$ = this.store.select(QuestionsState.userQuestionHistory(this.userUuid));
    this.inventoryItem = this.store.selectSnapshot(DetailsState.inventoryItem);
    this.showUserName = this._launchDarklyService.getFeatureFlag('sell-buyerUserNameEnabled', false);

    this.loading = true;
    this.questionHistory$
      .pipe(
        take(1),
        mergeMap(history => {
          if (history) {
            this.loading = false;
          }
          return this.store.dispatch(new GetUserQuestionHistory(this.inventoryItem.inventoryItemUuid, this.userUuid));
        }),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe();
  }

  localizeDate(date) {
    return this.dateUtilService.localizeDate(date);
  }

  localizeTime(time) {
    return this.dateUtilService.localizeTime(time, true);
  }
}
